/**
 * `useToast()` that degrades to a no-op without a `ToastProvider`.
 *
 * The app root mounts the provider (`main.tsx`), but the admin config page
 * preview and page-level tests render extranet cards without one — where
 * `useToast` throws. Same pattern as the configurable `ToggleRulesButton`.
 */

import { useToast, type ToastData } from '@components/base/feedback';

/** The `toast` function of the provider, or a no-op. */
export function useOptionalToast(): (options: Omit<ToastData, 'id'>) => void {
  try {
    return useToast().toast;
  } catch {
    return () => undefined;
  }
}
